import { useMutation } from '@tanstack/react-query';

import { SERVER_LOGOUT_KEY, serverLogout } from '../../utils/api';
import useAuth from '../useAuth';
import { useMessage } from '../../../hooks/useMessage';
import { axiosInt } from '../../../utils/axios';

interface IUseLogoutProps {
  onSuccess?: () => void;
  onError?: (error: unknown) => void;
}

const useLogout = ({ onSuccess, onError }: IUseLogoutProps = {}) => {
  const { logout: localLogout } = useAuth();
  const message = useMessage();

  const mutation = useMutation({
    mutationKey: [SERVER_LOGOUT_KEY],
    mutationFn: () => serverLogout(axiosInt),
    onSuccess: () => {
      localLogout();
      if (onSuccess) {
        onSuccess();
      } else {
        message.success('Logout successful.');
      }
    },
    onError: (error: unknown) => {
      localLogout();
      if (onError) {
        onError(error);
      } else {
        console.error('Server logout error:', error);
        message.warning('Logged out locally, but server logout failed.');
      }
    },
    retry: false,
  });

  return {
    logout: mutation.mutate,
    logoutAsync: mutation.mutateAsync,
    isLoggingOut: mutation.isPending,
    logoutError: mutation.error,
  };
};

export default useLogout;
